var lookingGlassIcon = require('../../static/design-system/icons/lookingGlass.svg');

var DESIGN_SYSTEM = {
  currentLocation: require('../../static/design-system/icons/currentLocation.svg'),
  lookingGlass: lookingGlassIcon,
  pin: require('../../static/design-system/icons/pin.svg')
};
var NUMBER_ICONS = {
  one: require('../../static/img/icon/numbers/one.svg'),
  two: require('../../static/img/icon/numbers/two.svg'),
  three: require('../../static/img/icon/numbers/three.svg'),
  four: require('../../static/img/icon/numbers/four.svg'),
  five: require('../../static/img/icon/numbers/five.svg'),
  six: require('../../static/img/icon/numbers/six.svg')
};
var SEARCH_ICONS = {
  back: require('../../static/img/icon/back.svg'),
  listview: require('../../static/img/icon/listview.svg'),
  mapview: require('../../static/img/icon/mapview.svg')
};
var ARROW_ICONS = {
  arrow: require('../../static/img/arrow.svg'),
  arrowDownSmall: require('../../static/design-system/icons/arrow-down-small.svg'),
  arrowLeftSmall: require('../../static/design-system/icons/arrow-left-small.svg'),
  arrowLeft: require('../../static/design-system/icons/arrow-left.svg'),
  arrowLineLeft: require('../../static/design-system/icons/arrowLine-left.svg'),
  arrowRightSmall: require('../../static/design-system/icons/arrow-right-small.svg')
};
var CIRCLE_ICONS = {
  'pointing-finger-circle': require('../../static/img/icon/circle/book.svg'),
  'checkmark-circle': require('../../static/img/icon/circle/check.svg'),
  'people-circle': require('../../static/img/icon/circle/friends.svg'),
  'calendar-circle': require('../../static/img/icon/circle/routine.svg'),
  'magnifying-glass-circle': require('../../static/img/icon/circle/search.svg'),
  'dumbbell-circle': require('../../static/img/icon/circle/weight.svg')
};
var TILE_ICONS = {
  calendar: require('../../static/img/icon/calendar-outline-blue.svg'),
  checkmark: require('../../static/img/icon/checkmark-outline-blue.svg'),
  dumbbell: require('../../static/img/icon/dumbbell-outline-blue.svg'),
  'key-white': require('../../static/img/icon/key-white.svg'),
  'magnifying-glass': require('../../static/img/icon/magnifying-glass-outline-blue.svg'),
  muscle: require('../../static/img/icon/muscle.svg'),
  'muscle-white': require('../../static/img/icon/muscle-white.svg'),
  people: require('../../static/img/icon/people-outline-blue.svg'),
  'pointing-finger': require('../../static/img/icon/pointing-finger-outline-blue.svg'),
  unlocked: require('../../static/img/icon/unlocked.svg'),
  'unlocked-white': require('../../static/img/icon/unlocked-white.svg')
};
var LINEART_BLUE = {
  map_pin: require('../../static/img/icon/lineart-blue-map-pin.svg')
};
var ACTIVITY_ICONS = {
  fitness: require('../../static/img/icon/fitness.svg'),
  gym: require('../../static/img/icon/gym.svg'),
  wellness: require('../../static/img/icon/wellness.svg'),
  all: lookingGlassIcon,
  default: require('../../static/img/icon/gym.svg')
};
var SOCIAL_SHARE_ICONS = {
  facebook: require('../../static/img/icon/social-facebook.svg'),
  twitter: require('../../static/img/icon/social-twitter.svg'),
  linkedin: require('../../static/img/icon/social-linkedin.svg'),
  email: require('../../static/img/icon/social-email.svg'),
  copy: require('../../static/img/icon/social-copy.svg')
};
var FILTER_ICONS = {
  checkmark: require('../../static/img/icon/checkmark-new.svg')
};
var STYLE_GUIDE = {
  calendar: require('../../style-guide/templates/static/assets/images/css/icons/calendar.svg')
};
export { DESIGN_SYSTEM, NUMBER_ICONS, SEARCH_ICONS, ARROW_ICONS, CIRCLE_ICONS, TILE_ICONS, LINEART_BLUE, ACTIVITY_ICONS, SOCIAL_SHARE_ICONS, FILTER_ICONS, STYLE_GUIDE };